import { CUSTOMS_VERIFY, NOTIFICATION_FUNCTIONCODE, REALNAME_CANCEL, } from './types';
export var setRealnameCancelRedux = function (payload) { return ({
    type: REALNAME_CANCEL,
    payload: payload,
}); };
export var setCustomsVerifyRedux = function (payload) { return ({
    type: CUSTOMS_VERIFY,
    payload: payload,
}); };
export var setNotificationFunctioncodeRedux = function (payload) { return ({
    type: NOTIFICATION_FUNCTIONCODE,
    payload: payload,
}); };
